module.exports = __webpack_public_path__ + "img/gb804.prt.3430fcc0.jpg";